import { useRequestData } from 'wsm-common-data';

export const useDeviceType = () => {
	const { deviceType } = useRequestData();
	return deviceType !== 'MOBILE';
};
